(function () {
  'use strict';
  if (customElements.get('sp-edition-select')) return;

  var refocus = false;

  class SpEditionSelect extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this.btn = this.querySelector('.sp-edition__btn');
      this.list = this.querySelector('.sp-edition__list');
      this.opts = Array.prototype.slice.call(this.querySelectorAll('.sp-edition__opt'));
      this.valueEl = this.querySelector('[data-sp-edition-value]');
      if (!this.btn || !this.list || !this.opts.length) return;
      this.active = -1;

      this.onDocPointer = this.onDocPointer.bind(this);
      this.btn.addEventListener('click', this.toggle.bind(this));
      this.btn.addEventListener('keydown', this.onBtnKey.bind(this));
      this.list.addEventListener('keydown', this.onListKey.bind(this));
      this.list.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.close(false);
      });
      this.opts.forEach((opt, i) => {
        opt.addEventListener('click', (e) => { e.preventDefault(); this.choose(i); });
        opt.addEventListener('mousemove', () => this.setActive(i, false));
      });

      this.syncFromRadios();
      this.setAttribute('ready', '');
      if (refocus) {
        refocus = false;
        this.btn.focus({ preventScroll: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onDocPointer, true);
    }

    radioFor(opt) {
      return opt ? document.getElementById(opt.dataset.inputId) : null;
    }

    selectedIndex() {
      for (var i = 0; i < this.opts.length; i++) {
        var r = this.radioFor(this.opts[i]);
        if (r && r.checked) return i;
      }
      for (var j = 0; j < this.opts.length; j++) {
        if (this.opts[j].getAttribute('aria-selected') === 'true') return j;
      }
      return 0;
    }

    syncFromRadios() {
      this.markSelected(this.selectedIndex());
    }

    markSelected(idx) {
      this.opts.forEach((opt, i) => opt.setAttribute('aria-selected', i === idx ? 'true' : 'false'));
      var name = this.opts[idx] && this.opts[idx].querySelector('.sp-edition__name');
      if (name && this.valueEl) this.valueEl.textContent = name.textContent;
    }

    isOpen() {
      return !this.list.hidden;
    }

    toggle() {
      if (this.isOpen()) this.close(true);
      else this.open();
    }

    open(at) {
      if (this.isOpen()) return;
      this.list.hidden = false;
      this.btn.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      var idx = this.selectedIndex();
      if (at === 'first') idx = 0;
      if (at === 'last') idx = this.opts.length - 1;
      this.setActive(idx, true);
      this.list.focus({ preventScroll: true });
            requestAnimationFrame(() => this.place());
      document.addEventListener('pointerdown', this.onDocPointer, true);
    }

    close(returnFocus) {
      if (!this.isOpen()) return;
      this.list.hidden = true;
      this.btn.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open', 'opens-up');
      this.list.removeAttribute('aria-activedescendant');
      this.opts.forEach((o) => o.classList.remove('is-active'));
      document.removeEventListener('pointerdown', this.onDocPointer, true);
      if (returnFocus) this.btn.focus({ preventScroll: true });
    }

        place() {
      this.classList.remove('opens-up');
      var l = this.list.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var over = l.bottom + 16 - vh;
      if (over > 0) {
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollBy({ top: over, behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    setActive(i, scroll) {
      if (i < 0 || i >= this.opts.length) return;
      this.active = i;
      this.opts.forEach((o, k) => o.classList.toggle('is-active', k === i));
      this.list.setAttribute('aria-activedescendant', this.opts[i].id);
      if (scroll && this.opts[i].scrollIntoView) this.opts[i].scrollIntoView({ block: 'nearest' });
    }

    choose(i) {
      var opt = this.opts[i];
      var radio = this.radioFor(opt);
      var wasFocusedInside = this.contains(document.activeElement);
      this.markSelected(i);
      this.close(true);
      if (!radio || radio.checked) return;
      radio.checked = true;
      refocus = wasFocusedInside;
      radio.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { noFocus: true } }));
    }

    onDocPointer(e) {
      if (!this.contains(e.target)) this.close(false);
    }

    onBtnKey(e) {
      switch (e.key) {
        case 'ArrowDown':
        case 'Down':
          e.preventDefault(); this.open(); break;
        case 'ArrowUp':
        case 'Up':
          e.preventDefault(); this.open(); break;
        case 'Home':
          e.preventDefault(); this.open('first'); break;
        case 'End':
          e.preventDefault(); this.open('last'); break;
        case 'Escape':
          if (this.isOpen()) { e.preventDefault(); this.close(true); }
          break;
        default:
      }
    }

    onListKey(e) {
      var n = this.opts.length;
      switch (e.key) {
        case 'ArrowDown':
        case 'Down':
          e.preventDefault(); this.setActive(Math.min(n - 1, this.active + 1), true); break;
        case 'ArrowUp':
        case 'Up':
          e.preventDefault(); this.setActive(Math.max(0, this.active - 1), true); break;
        case 'Home':
          e.preventDefault(); this.setActive(0, true); break;
        case 'End':
          e.preventDefault(); this.setActive(n - 1, true); break;
        case 'Enter':
        case ' ':
        case 'Spacebar':
          e.preventDefault(); if (this.active >= 0) this.choose(this.active); break;
        case 'Escape':
        case 'Esc':
          e.preventDefault(); e.stopPropagation(); this.close(true); break;
        case 'Tab':
          this.close(false); break;
        default:
      }
    }
  }

  customElements.define('sp-edition-select', SpEditionSelect);
})();
